import React, { memo } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Grid, Button, Box } from '@mui/material'
import { translate } from '../i18n'
import ExternSurface from './ExternSurface'
import { GoHomeProps } from './GoHome.types'

function GoHome({
    title = translate('errors.title') as string,
    showTitle,
    message,
    children,
}: GoHomeProps) {
    return (
        <ExternSurface
            title={title}
            showTitle={showTitle}
            description={message}
        >
            {children}
            <Grid item xs={12}>
                <Box my={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        size="large"
                        component={RouterLink}
                        to="/signin"
                    >
                        {translate('buttons.back_to_home')}
                    </Button>
                </Box>
            </Grid>
        </ExternSurface>
    )
}

export default memo(GoHome)
